import { useState } from 'react';
import { Button } from '../../components/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import config from '../../config';
import {
  DEFAULT_STREAM_FILTERS,
  buildStreamSearchParams,
  resolveStreamFilters,
  saveStreamFiltersToLocalStorage,
} from './utils/filters';

function Filters() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [initialFilters] = useState(() => resolveStreamFilters(searchParams));

 
  const [selectedSort, setSelectedSort] = useState(() =>
    initialFilters.sort === DEFAULT_STREAM_FILTERS.sort ? null : initialFilters.sort,
  );


  const interests = [{ id: 'popular', title: 'Популярности' }];

  const navigateToStreams = (filters, replace = false) => {
    const params = buildStreamSearchParams(filters);

    navigate(
      {
        pathname: config.ROUTES.STREAMS.LIST,
        search: params.toString() ? `?${params.toString()}` : '',
      },
      { replace },
    );
  };

  const onSaveFilter = () => {
    const nextFilters = {
      sort: selectedSort ?? DEFAULT_STREAM_FILTERS.sort,
    };

    saveStreamFiltersToLocalStorage(nextFilters);
    navigateToStreams(nextFilters, true);
  };

  return (
    <div className="w-[100%] h-[auto] pt-[32px] flex justify-center">
      <div className="h-[auto] flex flex-col justify-start items-start w-[343px] relative">
        <div className="w-full flex justify-between items-center">
          <div onClick={() => navigateToStreams(initialFilters)}>
            <img alt="Назад" src="/icons/Button-back.svg" className="mt-3 w-[44px] h-[44px]" />
          </div>
          <div
            onClick={() => {
              setSelectedSort(null);
            }}
          >
            <p className="text-white mt-3">Сбросить</p>
          </div>
        </div>

        <h1 className="font-raleway font-semibold mt-6 text-white text-[26px]">Фильтры</h1>

        <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Отсортировать по:</h1>
        <div className="flex flex-wrap  gap-[16px] mt-[16px]">
          {interests.map((option) => (
            <div
              key={option.id}
              onClick={() => setSelectedSort((prev) => (prev === option.id ? null : option.id))}
              className={`w-[auto] p-3 h-[48px] rounded-[400px] flex justify-center items-center text-[18px] font-light text-white gap-[8px] cursor-pointer transition-all 
            ${
              selectedSort === option.id
                ? 'bg-[#043939] border-[1.5px] border-[#a1f69e]'
                : 'bg-[#022424] border-[1px] border-[#233636]'
            }`}
            >
              <span>{option.title}</span>
            </div>
          ))}
        </div>

        <div className={'fixed bottom-6'}>
          <Button onClick={onSaveFilter}>Применить</Button>
        </div>
      </div>
    </div>
  );
}

export default Filters;
